import { createSlice } from '@reduxjs/toolkit'
import { uniqueArray } from '../utilities'

export const sentMediaSlice = createSlice({
    name: 'sentMedia',
    initialState: {
        ids: [],
        error: null
    },
    reducers: {
        clearId: (state, { payload }) => {
            const copy = state.ids.filter(id => id !== payload)
            state.ids = copy
        },
        addIds: (state, { payload }) => {
            const uniqueIds = uniqueArray([...state.ids, payload]).filter(Boolean)
            state.ids = uniqueIds
        },
        failed: (state, { payload }) => {
            state.error = payload
        }
    }
})

export default sentMediaSlice.reducer

export const { clearId, addIds, failed } = sentMediaSlice.actions

export const selectSentMedia = state => state.sentMedia
